import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '诊后健康管理平台',
  pwa: true,
  logo: '/image@1x.png',
  iconfontUrl: '',
  collapsed: false, // 默认展开侧边栏
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    header: {
      heightLayoutHeader: 64, // 增加顶栏高度
    },
    pageContainer: {
      paddingBlockPageContainerContent: 12, // 减小上下内边距（默认24）
      paddingInlinePageContainerContent: 24, // 减小左右内边距（默认40）
    },
  },
};

export default Settings;
